import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'uo-sms-terms',
  templateUrl: './sms-terms.component.html',
  styleUrls: ['./sms-terms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmsTermsComponent {}
